/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { generateSimplestList, SimpleAttributeList, simpleLocalAttribute } from './SimpleAttribute';
import { DefaultSplitDataRenderType, SplitData } from './SplitData';

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface LocationFields {
	id: string;
	name?: string;
	locationColor?: string;
	color?: string;
}

export class Location extends SplitData<LocationFields, DefaultSplitDataRenderType> {
	protected useInPlace: boolean = true;
	protected attributeList: SimpleAttributeList = Object.assign(
		generateSimplestList(['id', 'name', 'locationColor']),
		{
			color: simpleLocalAttribute,
		}
	);

	public constructor(id: string) {
		super(id, DefaultSplitDataRenderType.database);
	}
}
